import '../../../../lib/style/index.less';
import '../../../../lib/collapse/style';
import '../../../../lib/grid/style';
import '../../../../lib/tag/style';
import '../../../../lib/popover/style';
import '../../../../lib/card/style';
import 'choerodon-ui/pro/lib/typography/style';
import 'choerodon-ui/pro/lib/table/style';
import './index.less';
// style dependencies
import '../../modal-container/style';
